import {useEffect, useState} from "react"

export const useDarkMode = () => {
	const [isDark, setIsDark] = useState(() => {
		if (typeof window === "undefined") return false
		return (
			localStorage.getItem("theme") === "dark" ||
			(!localStorage.getItem("theme") && window.matchMedia("(prefers-color-scheme: dark)").matches)
		)
	})

	useEffect(() => {
		const root = document.documentElement
		if (isDark) {
			root.classList.add("dark")
			localStorage.setItem("theme", "dark")
		} else {
			root.classList.remove("dark")
			localStorage.setItem("theme", "light")
		}
	}, [isDark])

	return {isDark, toggle: () => setIsDark((d) => !d)}
}
